import Request from '../../services/Request';
import ResponseChecker from '../../services/ResponseChecker';
import NotiMessage from '../../services/NotiMessage';

const notiMessage = new NotiMessage('success');
// URL //
const eachUrl = 'sympton/getEach?';
const allUrl = 'sympton/get?';
const storeUrl = 'sympton/store';
const updateUrl = 'sympton/update?';
const deleteUrl = 'sympton/delete?';


const state = {
  symptons: [],
  sympton: {},
};
const getters = {};
const mutations = {
  SET_SYMPTONS(state, payload) {
    state.symptons = payload.data.data
  },
  SET_SYMPTON(state, payload) {
    state.sympton = payload.data.data
  },
  ADD_SYMPTON(state, payload) {
    state.symptons.push(payload.data.data)
  },
  REMOVE_SYMPTON(state, payload) {
    const symptons = state.symptons.filter((sympton) => sympton.id != payload.id)
    state.symptons = [...symptons]
  }
};

const actions = {
  async getSymptons({ commit }) {
    const response = await Request.get_data(allUrl)
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_SYMPTONS", response);
  },
  async getSympton({ commit }, id) {
    const response = await Request.get_data(eachUrl, { column: 'id', value: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_SYMPTON", response);
  },
  async createSympton({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_SYMPTON", response);
      notiMessage.displayNotiMsg('Saved Success')
      return true
    }
    return false;
  },
  async updateSympton(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg('Updated Success')
      return true
    }
    return false;
  },
  async deleteSympton({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_SYMPTON", payload);
      notiMessage.displayNotiMsg('Deleted Success')
      return true
    }
    return false;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
